const Email = ({
  color = "currentColor",
  width = 24,
  height = 24,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 125 125"
    width={width}
    height={height}
    fill={color}
    aria-hidden="true"
    {...props}
  >
    <path d="M105.182 97.82H19.818A10.477 10.477 0 0 1 9.353 87.354v-52.72a10.477 10.477 0 0 1 10.465-10.466h85.364a10.477 10.477 0 0 1 10.465 10.466v52.72a10.477 10.477 0 0 1-10.465 10.466zM19.818 28.168a6.472 6.472 0 0 0-6.465 6.466v52.72a6.472 6.472 0 0 0 6.465 6.466h85.364a6.472 6.472 0 0 0 6.465-6.466v-52.72a6.472 6.472 0 0 0-6.465-6.466z" />
    <path d="M62.5 72.764a2 2 0 0 1-1.324-.5l-48.2-42.548 2.647-3L62.5 68.1l46.879-41.379 2.647 3-48.2 42.548a1.994 1.994 0 0 1-1.326.495z" />
    <path d="m11.888 91.54 32.38-36.895 3.009 2.64-32.38 36.894zM77.825 57.247l3.008-2.64L113.214 91.5l-3.008 2.64z" />
  </svg>
);

export default Email;
